/**
 * A light tap of vibration on the confirmations that matter: a scan read, a
 * case marked done, a case flagged. Request of 5 October 2026, section 5.
 *
 * Android only: iPhone gives a web page no vibration at all, so there it is
 * simply skipped. A person can turn it off on their profile; the choice is a
 * habit of the device and is set here once at start up (see App).
 */

/** The device setting it is remembered under. */
export const HAPTICS_SETTING = 'haptics';

let enabled = true;

/** Set from the device's saved choice, and again whenever it changes. */
export function setHapticsEnabled(on: boolean): void {
  enabled = on;
}

export function hapticsEnabled(): boolean {
  return enabled;
}

/** Whether this device can vibrate at all, to offer the setting only where it does something. */
export function hapticsSupported(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
}

const PATTERN: Record<'success' | 'warning', number[]> = {
  /** A scan read, a case marked done. */
  success: [18],
  /** A case flagged: two short taps, so it does not feel like a success. */
  warning: [14, 60, 14],
};

export function haptic(kind: keyof typeof PATTERN): void {
  if (!enabled || !hapticsSupported()) return;
  try {
    navigator.vibrate(PATTERN[kind]);
  } catch {
    // A vibration is a nicety; nothing depends on it.
  }
}
